import type { LogoSize } from '../../ShipmentLogo';
import {
  DefaultLogo,
  FirstLetterWrapper,
  MerchantFirstLetter,
  MerchantFirstLetterBackground,
  MerchantLogoImage,
  MerchantLogoWraper,
} from './CommonLogos.styles';

const MerchantLogoWithLogo = ({
  logo,
  size,
  merchantName,
}: { logo: string; size: Lowercase<LogoSize>; merchantName?: string }) => {
  return (
    <MerchantLogoWraper hasLogo size={size}>
      <MerchantLogoImage src={logo} alt={merchantName ?? 'Merchant Logo'} />
    </MerchantLogoWraper>
  );
};

const MerchantDefaultLogo = ({ merchantName, size }: { merchantName: string; size: Lowercase<LogoSize> }) => {
  return (
    <MerchantLogoWraper size={size}>
      <DefaultLogo alt={merchantName} />
      <FirstLetterWrapper>
        <MerchantFirstLetterBackground />
        <MerchantFirstLetter>{merchantName[0].toUpperCase()}</MerchantFirstLetter>
      </FirstLetterWrapper>
    </MerchantLogoWraper>
  );
};

const DefaultLogoWithoutLetter = ({ size }: { size: Lowercase<LogoSize> }) => {
  return (
    <MerchantLogoWraper size={size}>
      <DefaultLogo />
    </MerchantLogoWraper>
  );
};

export { MerchantLogoWithLogo, MerchantDefaultLogo, DefaultLogoWithoutLetter };
